import { MsftSmeMock } from './base/msft-sme.mock';
import { LoggingMock } from './diagnostics/logging.mock';
import { ConsoleMock } from './test-utilities/console.mock';

export const strings = require('./generated/strings/strings.json');
export function setUpMocks() {
    MsftSmeMock.mockStrings(strings);
    MsftSmeMock.mockSelf({
        Init: {
            isShell: true,
            Environment: {
                configuration: {}
            },
            moduleName: 'testModule',
            shellVersion: '11.22.33'
        }
    });
    ConsoleMock.mockConsole();
    LoggingMock.mockLog();
}
